
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 12 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.979 11.076a.75.75 0 00.097-1.058l-2.723-3.27h8.897a.75.75 0 00.75-.75.75.75 0 00-.75-.75H2.353l2.723-3.271a.751.751 0 00-1.155-.96l-3.75 4.5-.068.113-.053.098a.75.75 0 000 .54l.053.097.067.113 3.751 4.5a.75.75 0 001.058.098z","fill":"#001C45"}})])
          )
        }
      }
    